import axios from 'axios';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 請求攔截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sessionToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sessionToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// 伺服器管理 API
export const serverApi = {
  getAll: () => api.get('/ServerSetting'),
  getById: (id: number) => api.get(`/ServerSetting/${id}`),
  create: (data: any) => api.post('/ServerSetting', data),
  update: (id: number, data: any) => api.put(`/ServerSetting/${id}`, data),
  delete: (id: number) => api.delete(`/ServerSetting/${id}`),
};

// 工作站管理 API
export const stationApi = {
  getAll: () => api.get('/Station'),
  getById: (id: number) => api.get(`/Station/${id}`),
  create: (data: any) => api.post('/Station', data),
  update: (id: number, data: any) => api.put(`/Station/${id}`, data),
  delete: (id: number) => api.delete(`/Station/${id}`),
};

// 裝置管理 API
export const deviceApi = {
  getAll: () => api.get('/DeviceController'),
  getById: (id: number) => api.get(`/DeviceController/${id}`),
  getRawRecords: (mac: string, includeMeasurements?: boolean, page?: number, pageSize?: number) => 
    api.get(`/DeviceController/raw-records/${mac}`, {
      params: { includeMeasurements, page, pageSize }
    }),
  getCalibrationRecords: (mac: string, includeMeasurements?: boolean, page?: number, pageSize?: number) => 
    api.get(`/DeviceController/calibration-records/${mac}`, {
      params: { includeMeasurements, page, pageSize }
    }),
};

// 校正記錄 API
export const calibrationApi = {
  getAll: () => api.get('/CalibrationRecord'),
  getById: (id: number) => api.get(`/CalibrationRecord/${id}`),
  create: (data: any) => api.post('/CalibrationRecord', data),
  update: (id: number, data: any) => api.put(`/CalibrationRecord/${id}`, data),
  delete: (id: number) => api.delete(`/CalibrationRecord/${id}`),
};

// 感測器資料 API
export const sensorDataApi = {
  getAll: (page?: number, pageSize?: number, mac?: string) => 
    api.get('/SensorData', {
      params: { page, pageSize, mac }
    }),
  getById: (id: number) => api.get(`/SensorData/${id}`),
  getPackets: (id: number) => api.get(`/SensorData/packets/${id}`),
};

// 生產訂單 API
export const productionOrderApi = {
  getAll: () => api.get('/ProductionOrder'),
  getById: (id: number) => api.get(`/ProductionOrder/${id}`),
  create: (data: any) => api.post('/ProductionOrder', data),
  update: (id: number, data: any) => api.put(`/ProductionOrder/${id}`, data),
  delete: (id: number) => api.delete(`/ProductionOrder/${id}`),
};

// 出貨訂單 API
export const shippingOrderApi = {
  getAll: () => api.get('/ShippingOrder'),
  getById: (id: number) => api.get(`/ShippingOrder/${id}`),
  create: (data: any) => api.post('/ShippingOrder', data),
  update: (id: number, data: any) => api.put(`/ShippingOrder/${id}`, data),
  delete: (id: number) => api.delete(`/ShippingOrder/${id}`),
};

// 客戶管理 API
export const customerApi = {
  getAll: () => api.get('/Customer'),
  getById: (id: number) => api.get(`/Customer/${id}`),
  create: (data: any) => api.post('/Customer', data),
  update: (id: number, data: any) => api.put(`/Customer/${id}`, data),
  delete: (id: number) => api.delete(`/Customer/${id}`),
};

export default api;
